export default {"src":"/_next/static/media/short-answer.bdb957d5.svg","height":40,"width":41};